import { useState, useEffect } from "react";
import Map from "../../components/Map";
import "./styles/Fireworks.css";
import Clock from "../../components/Clock";
import search from "/assets/icon/Search.svg";
import filter from "/assets/icon/Filter.svg";
import Vector from "/Vector.png?url";
import eye from "/assets/Eye.png";
import { useLocation } from "react-router";
import UserStatus from "../../components/UserStatus";
import Detail from "../../components/Detail";
import hail from "/assets/hail.png";
import windy from "/assets/windy.png";
import snow from "/assets/snow.png";
import Lamp from "/assets/lamp.png";

function Fireworks() {
  const [activeDetail, setActiveDetail] = useState(null);
  const [data, setData] = useState({
    station: 0,
    stationId: 0,
    co2: 0,
    pm1: 0,
    pressure: 0,
    windSpeed: 0,
    temperature: 0,
    pm25: 0,
    pm10: 0,
  });
  const [tableData, setTableData] = useState([
    {
      no: 1,
      stationCode: "A254006",
      stationName: "แม่ฮ่องสอน",
      coordinates: "13.813,100.077",
      temperature: 32,
      co2: 197,
      pm25: 126,
      status: "ปกติ",
    },
    {
      no: 2,
      stationCode: "A254006",
      stationName: "แม่ฮ่องสอน",
      coordinates: "13.813,100.077",
      temperature: 41,
      co2: 131,
      pm25: 126,
      status: "ปกติ",
    },
  ]);
  const location = useLocation();

  const handleDetailClick = (row) => {
    setActiveDetail(row);
  };

  const handleCloseDetail = () => {
    setActiveDetail(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (location.state?.lat && location.state?.lon) {
        try {
          const response = await fetch(
            `https://api.airvisual.com/v2/nearest-station?lat=${location.state.lat}&lon=${location.state.lon}`
          );
          const result = await response.json();
          setData(result.data.current.pollution);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();
  }, [location.state?.lat, location.state?.lon]);

  return (
    <div className="containerPage">
      <div className="sections1">
        <h1>ไฟป่า</h1>
        <h2>
          <Clock />
        </h2>
      </div>
      <div className="sections2">
        <div className="area-chart-container">
          <img src={Lamp} alt="Lamp" className="Lamp" />
          <div className="titleFirework">
            <img src={Vector} alt="Vector" />
          </div>
          <div className="detailFirework">
            <img src={windy} alt="windy" className="title" />
            <img src={snow} alt="rain" className="title" />
            <img src={hail} alt="hail" className="title" />
            <h5>ความกดอากาศ</h5>
            <h5>ความเร็วลม</h5>
            <h5>ทิศทางลม</h5>
            <span>{data.pressure}</span>
            <span>{data.windSpeed}</span>
            <span>{data.co2}</span>
            <h5>ปริมาณ CO2</h5>
            <h5>อุณหภูมิ (°C) </h5>
            <h5>ปริมาณฝุ่นควัน</h5>
            <span>{data.pm1}</span>
            <span>{data.temperature}</span>
            <span>{data.pm25}</span>
            <h5>PM 1 µg./m3</h5>
            <h5>PM 2.5 µg./m3</h5>
            <h5>PM 10 µg./m3</h5>
            <span>{data.pm25}</span>
            <span>{data.pm10}</span>
          </div>
        </div>
        <div className="areaMap">
          <Map />
        </div>
      </div>
      <div className="section3">
        <div className="led-section">
          <div className="search-bar">
            <img src={search} alt="search" className="search-user" />
            <input
              type="text"
              placeholder="ค้นหารหัสเสา ชื่อเสา ตำแหน่งติดตั้ง"
            />
            <div>
              <img src={filter} alt="filter" className="filter-user" />
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>No</th>
                <th>รหัสเสา</th>
                <th>ชื่อเสา</th>
                <th>พิกัด</th>
                <th>อุณหภูมิ (°C)</th>
                <th>CO2</th>
                <th>PM2.5 (µg/m³)</th>
                <th>สถานะเปิดปิด</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td>{row.no}</td>
                  <td>{row.stationCode}</td>
                  <td>{row.stationName}</td>
                  <td>{row.coordinates}</td>
                  <td>{row.temperature}</td>
                  <td>{row.co2}</td>
                  <td>{row.pm25}</td>
                  <td>
                    <UserStatus />
                  </td>
                  <td>
                    <img src={eye} alt="eye" onClick={() => handleDetailClick(row)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {activeDetail && (
        <Detail
          title="ไฟป่า"
          weatherData={activeDetail}
          onClose={handleCloseDetail}
        >
          <label>ปริมาณ CO2</label>
          <strong>{activeDetail.co2}</strong>
          <label>อุณหภูมิ (°C) </label>
          <strong>{activeDetail.temperature}</strong>
          <label>ปริมาณฝุ่นควัน</label>
          <strong>{activeDetail.pm25}</strong>
        </Detail>
      )}
    </div>
  );
}

export default Fireworks;
